import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-simple-pagination',
  template: `
    <div class="d-flex justify-content-end align-items-center p-3">
      <span class="mr-3 text-muted">Página {{ currentPage }}</span>
      <button mat-button color="primary" [disabled]="currentPage === 1" (click)="changePage(-1)">
        <i class="fas fa-chevron-left mr-1"></i> Anterior
      </button>
      <button mat-button color="primary" [disabled]="!hasNextPage" (click)="changePage(1)">
        Próxima <i class="fas fa-chevron-right ml-1"></i>
      </button>
    </div>
  `
})
export class SimplePaginationComponent {
  @Input() currentPage: number = 1;
  @Input() hasNextPage: boolean = true;
  @Output() pageChange = new EventEmitter<number>();

  changePage(delta: number) {
    this.pageChange.emit(this.currentPage + delta);
  }
}